export const TOOL_COLORS = {
  merge: {
    primary: '#E8445A',
    surface: '#FFF0F2',
    border: '#FFD6DB',
    shadow: 'rgba(232, 68, 90, 0.28)',
  },
  remove: {
    primary: '#EF4444',
    surface: '#FEF2F2',
    border: '#FECACA',
    shadow: 'rgba(239, 68, 68, 0.28)',
  },
  organize: {
    primary: '#8B5CF6',
    surface: '#F5F3FF',
    border: '#DDD6FE',
    shadow: 'rgba(139, 92, 246, 0.28)',
  },
  split: {
    primary: '#3B82F6',
    surface: '#EFF6FF',
    border: '#DBEAFE',
    shadow: 'rgba(59, 130, 246, 0.28)',
  },
  rotate: {
    primary: '#F59E0B',
    surface: '#FFFBEB',
    border: '#FDE68A',
    shadow: 'rgba(245, 158, 11, 0.28)',
  },
  lock: {
    primary: '#7C5CBF',
    surface: '#F3EEFF',
    border: '#E0D4FF',
    shadow: 'rgba(124, 92, 191, 0.28)',
  },
  unlock: {
    primary: '#0EA5B0',
    surface: '#EDFCFD',
    border: '#BFEFEF',
    shadow: 'rgba(14, 165, 176, 0.28)',
  },
  compress: {
    primary: '#10B981',
    surface: '#ECFDF5',
    border: '#A7F3D0',
    shadow: 'rgba(16, 185, 129, 0.28)',
  },
  sign: {
    primary: '#6366F1',
    surface: '#EEF2FF',
    border: '#C7D2FE',
    shadow: 'rgba(99, 102, 241, 0.28)',
  },
} as const;
